module.exports = __webpack_public_path__ + "static/img/2508_phase_function_Paper_PointsHejduk_Prediction.f2cb000.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2508_phase_function_Paper_PointsHejduk_Prediction.png
// module id = jMXw
// module chunks = 0